/**
 * Helper to sort available languages based
 * on the users browser language preferences
 */

import { AvailableLanguages, LanguageInfo } from "../../../types/rootDataTypes";

// sort available languages based on browser lang preferences
const sortLangs = (availLangs: AvailableLanguages, prefLangs: string[]) => {
  const sortedLanguages: LanguageInfo[] = [];

  prefLangs.forEach((lang: string) => {
    if (availLangs[lang]) {
      sortedLanguages.push(availLangs[lang]);
    }
  });

  // If we wanted to be more efficient, we could use a Set here,
  // but the list of languages is always going to be small.
  Object.values(availLangs).forEach((lang: LanguageInfo) => {
    if (!sortedLanguages.includes(lang)) {
      sortedLanguages.push(lang);
    }
  });


  return sortedLanguages;
};

export default sortLangs;
